import { Dispatch } from "redux";

import { ACTIONS } from "./types";
import store from "config/store";
import { ZendeskKnowledgeApi } from "api-client";
import { getAuthConfiguration } from "utils/getAuthConfiguration";

export const getZendeskKnowledge = () => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const zendeskPOCApi = new ZendeskKnowledgeApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.GET_ZENDESK_KNOWLEDGE_REQUEST,
        });
        const res = await zendeskPOCApi.getZendeskKnowledgeApiZendeskKnowledgeGet();
        dispatch({
            type: ACTIONS.GET_ZENDESK_KNOWLEDGE_SUCCESS,
            payload: res,
        });
    } catch (e) {
        dispatch({
            type: ACTIONS.GET_ZENDESK_KNOWLEDGE_FAILURE,
        });
        throw e;
    }
};
